import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

const navItems = [
  { to: '/shop', icon: '⌘', label: 'Магазин' },
  { to: '/list', icon: '✓', label: 'Мои покупки' },
  { to: '/support', icon: '?', label: 'Поддержка' },
];

export default class Menu extends Component {
  handleLogout = () => {
    this.props.auth().then(() => {
      window.location.href = '/';
    });
  };

  render() {
    const displayName = this.props.displayName || 'Пользователь ZielStk';
    const initial = displayName.trim().charAt(0).toUpperCase() || 'Z';

    return (
      <aside className="app-sidebar">
        <div className="app-sidebar__brand">
          <span className="app-sidebar__brand-mark">Z</span>
          <span>
            <strong>ZielStk</strong>
            <small>Studienkolleg</small>
          </span>
        </div>

        <div className="app-user">
          {this.props.imageUrl ? (
            <img className="app-user__avatar" alt="" src={this.props.imageUrl} />
          ) : (
            <span className="app-user__avatar app-user__avatar--fallback">{initial}</span>
          )}
          <div className="app-user__copy">
            <strong>{displayName}</strong>
            <span>{this.props.userEmail}</span>
          </div>
        </div>

        <nav className="app-navigation" aria-label="Личный кабинет">
          {navItems.map(({ to, icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `app-navigation__link${isActive ? ' app-navigation__link--active' : ''}`
              }
            >
              <span className="app-navigation__icon" aria-hidden="true">{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>

        <button type="button" className="app-logout" onClick={this.handleLogout}>
          Выйти из аккаунта
        </button>
      </aside>
    );
  }
}
